export const utcFormat = 'YYYY-MM-DDTHH:mm:ss[Z]';

export const dateShowFormatEn = 'dd/MM/yyyy';
export const dateShowFormatCz = 'dd.MM.yyyy';
export const dateTimeShowFormat = 'dd.MM.yyyy HH:mm';
export const dateTimeWithSecondsShowFormat = 'L HH:mm:ss';
export const hoursMinutesShowFormat = 'HH:mm';
export const hoursMinutesSecondsShowFormat = 'HH:mm:ss';

export const generalDateTimeWithSecondsShowFormat = 'L HH:mm:ss';

export const dateSubmitFormat = 'yyyy-MM-dd';

/**
 * Returns show date format according to current language
 * default EN
 * @param lang
 */
export const getCurrentLangFormat = (lang?: string | null) => {
  if (lang?.toLocaleLowerCase() === 'cz') return dateShowFormatCz;
  return dateShowFormatEn;
};
